import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGetJournalEntryDetails } from "../../../../hooks/api/queries";

const JournalEntryDetails = () => {
  const { reference } = useParams();
  const navigate = useNavigate();
  const {
    data: journalEntryDetails,
    isFetching: isFetchingJournalEntryDetails,
    refetch: refetchJournalEntryDetails,
  } = useGetJournalEntryDetails(reference, {
    enabled: !!reference,
  });
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Journal Entry Details"
      description="View journal entry details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames="btn btn--outline"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon="angle-left"
                className="mr-3"
                style={{ fontSize: "18px" }}
              />
              <span>Back</span>
            </primaryComponents.Button>
            <h4 className="font-weight-semibold mb-0">
              Journal Entry #{journalEntryDetails?.reference}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isFetchingJournalEntryDetails}
          >
            <secondaryComponents.JournalEntryDetails
              journalEntryDetails={journalEntryDetails}
              refetchJournalEntryDetails={refetchJournalEntryDetails}
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default JournalEntryDetails;
